"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$1yearAgo = exports.$6monthsAgo = exports.$30daysAgo = exports.$6hoursAgo = exports.$2hoursAgo = exports.$1hourAgo = exports.$2daysAgo = exports.$1dayAgo = exports.$1weekAgo = exports.$30minutesAgo = exports.$5minutesAgo = exports.$24HoursAgo = exports.$12hoursAgo = exports.$1year = exports.$6months = exports.$1month = exports.$30days = exports.$2weeks = exports.$2days = exports.$24hours = exports.$12hours = exports.$6hours = exports.$2hours = exports.$30minutes = exports.$15minutes = exports.$10minutes = exports.$5minutes = exports.$4minutes = exports.$3minutes = exports.$2minutes = exports.$30seconds = exports.$15seconds = exports.$10seconds = exports.$7seconds = exports.$6seconds = exports.$5seconds = exports.$4seconds = exports.$3seconds = exports.$2seconds = exports.$1week = exports.$1day = exports.$1hour = exports.$1minute = exports.$1second = void 0;
exports.$1second = 1000;
exports.$1minute = 60 * exports.$1second;
exports.$1hour = 60 * exports.$1minute;
exports.$1day = 24 * exports.$1hour;
exports.$1week = 7 * exports.$1day;
exports.$2seconds = 2 * exports.$1second;
exports.$3seconds = 3 * exports.$1second;
exports.$4seconds = 4 * exports.$1second;
exports.$5seconds = 5 * exports.$1second;
exports.$6seconds = 6 * exports.$1second;
exports.$7seconds = 7 * exports.$1second;
exports.$10seconds = 10 * exports.$1second;
exports.$15seconds = 15 * exports.$1second;
exports.$30seconds = 30 * exports.$1second;
exports.$2minutes = 2 * exports.$1minute;
exports.$3minutes = 3 * exports.$1minute;
exports.$4minutes = 4 * exports.$1minute;
exports.$5minutes = 5 * exports.$1minute;
exports.$10minutes = 10 * exports.$1minute;
exports.$15minutes = 15 * exports.$1minute;
exports.$30minutes = 30 * exports.$1minute;
exports.$2hours = 2 * exports.$1hour;
exports.$6hours = 5 * exports.$1hour;
exports.$12hours = 12 * exports.$1hour;
exports.$24hours = 24 * exports.$1hour;
exports.$2days = 2 * exports.$1day;
exports.$2weeks = 2 * exports.$1week;
exports.$30days = 30 * exports.$1day;
exports.$1month = 30 * exports.$1day;
exports.$6months = 180 * exports.$1day;
exports.$1year = 365 * exports.$1day;
const $12hoursAgo = () => new Date(Date.now() - exports.$12hours);
exports.$12hoursAgo = $12hoursAgo;
const $24HoursAgo = () => new Date(Date.now() - exports.$24hours);
exports.$24HoursAgo = $24HoursAgo;
const $5minutesAgo = () => new Date(Date.now() - exports.$5minutes);
exports.$5minutesAgo = $5minutesAgo;
const $30minutesAgo = () => new Date(Date.now() - exports.$30minutes);
exports.$30minutesAgo = $30minutesAgo;
const $1weekAgo = () => new Date(Date.now() - exports.$1week);
exports.$1weekAgo = $1weekAgo;
const $1dayAgo = () => new Date(Date.now() - exports.$1day);
exports.$1dayAgo = $1dayAgo;
const $2daysAgo = () => new Date(Date.now() - exports.$2days);
exports.$2daysAgo = $2daysAgo;
const $1hourAgo = () => new Date(Date.now() - exports.$1hour);
exports.$1hourAgo = $1hourAgo;
const $2hoursAgo = () => new Date(Date.now() - exports.$2hours);
exports.$2hoursAgo = $2hoursAgo;
const $6hoursAgo = () => new Date(Date.now() - exports.$6hours);
exports.$6hoursAgo = $6hoursAgo;
const $30daysAgo = () => new Date(Date.now() - exports.$30days);
exports.$30daysAgo = $30daysAgo;
const $6monthsAgo = () => new Date(Date.now() - exports.$6months);
exports.$6monthsAgo = $6monthsAgo;
const $1yearAgo = () => new Date(Date.now() - exports.$1year);
exports.$1yearAgo = $1yearAgo;
